import { render, staticRenderFns } from "./SelectDesign.vue?vue&type=template&id=7f20185c&"
import script from "./SelectDesign.vue?vue&type=script&lang=ts&"
export * from "./SelectDesign.vue?vue&type=script&lang=ts&"
import style0 from "./SelectDesign.vue?vue&type=style&index=0&id=7f20185c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports